// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3skER","notes":"Notes_notes__3zRHu","note":"Notes_note__23-Sw","markdown":"Notes_markdown__31qaC"};